import { Component, OnInit, Input, OnDestroy, DoCheck } from '@angular/core';
import { ReportExportationService } from './services/report-exportation.service';
import { ExportReport } from './models/export-report.model';
import { Subscription } from 'rxjs';
import { Report } from '../../../report/models/report.model';
import { OrientationEnum, ReportSettings } from '../../report-settings/models/reportsettings.model';
import { FileOption } from './models/file-option.model';
import { ExportReportToFile } from './requests/export-report-to-file.request';
import { ExportActionEnum } from './enums/export-action.enum';
import { RTEAlertService, RteDialog } from 'rte-library';
import { getAllColumns } from 'src/app/reports/helpers/column.helper';
import { getExportQueryParameter, getQueryParameterList } from 'src/app/reports/helpers/query-parameter.helper';
import { getAllFilters } from 'src/app/reports/helpers/filter.helper';
import { SchemaForm } from 'src/app/reports/shared/rte-form/schema/schema.model';
import { isFormValid } from 'src/app/reports/shared/rte-form/schema/schema.helper';
import { FileExtensionEnum } from './enums/file-extension.enum';
import { ReportExportionSettings } from './report-exportation-settings-dialog/report-exportation-settings.model';
import { MatDialog } from '@angular/material';
import { ReportExportationSettingsDialogComponent } from './report-exportation-settings-dialog/report-exportation-settings-dialog.component';

@Component({
  selector: 'app-report-exportation',
  templateUrl: './report-exportation.component.html',
  styleUrls: ['./report-exportation.component.scss']
})
export class ReportExportationComponent implements OnInit, OnDestroy {

  //#region Inputs

  @Input() parameters: any;
  @Input() report: Report;
  @Input() settings: ReportSettings;
  @Input() form: SchemaForm;

  //#endregion

  //#region Properties

  request: ExportReportToFile;
  subscriptions: Subscription = new Subscription();
  options = new Array<FileOption>();

  //#endregion

  //#region Ctor

  constructor(private service: ReportExportationService,
    private exportService: ReportExportationService,
    private alert: RTEAlertService,
    private dialog: RteDialog
  ) {
    this.options = this.exportService.getExtensionsOptions();
  }

  //#endregion

  //#region Interface Implementations

  ngOnInit() {
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  instanceRequest(config : ReportExportionSettings) {
    const parameterList = getQueryParameterList(this.parameters, getAllFilters(this.report));
    this.request = {
      Name : this.report.Name,
      Query : this.report.QueryDetail ? this.report.QueryDetail : this.report.Query,
      ProviderId : this.report.Provider.Id,
      Parameters : getExportQueryParameter(this.report, parameterList),
      Columns : getAllColumns(this.report),
      FileExtension : config.Extension,
      Orientation: OrientationEnum.Portrait,
      ShowHeader: config.ShowHeader,
      Delimiter: config.Delimiter,
      CompressFile: config.CompressFile
    };
  }

  //#endregion

  //#region Methods

  createExportFile(action: ExportActionEnum) {
    
    this.subscriptions.add(
        this.service.exportReportToFile(this.request).subscribe(( result: ExportReport) => {
        this.alert.info('Exportação em execução!', 'Ao final da exportação você será notificado.', { expanded: true });
      })
    );
  }

  //#endregion

  //#region Events

  onDownloadClick() {
    const isValid = isFormValid(this.form, this.parameters);

    if (isValid){
      let config : ReportExportionSettings = {
        Extension: FileExtensionEnum.CSV,
        ShowHeader: true,
        Delimiter: ';',
        Options: this.options,
        CompressFile: false
      };

      let componentRef = this.dialog.open(ReportExportationSettingsDialogComponent, {data: config});

      componentRef.componentInstance.confirm.subscribe(x =>{
        this.instanceRequest(config);
        this.createExportFile(ExportActionEnum.Download);
      });      
    } else {
      this.alert.warning('Há um ou mais campos inválidos. Por favor, verifique os filtros');
    }
  }
  //#endregion
}
